import React from 'react';
import R from 'ramda';
import Helmet from 'react-helmet';
import { Header, Loading, Footer } from '../app/components';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import { firebase } from '../../common/lib/redux-firebase';
import { onPropertyDetailsPresence } from '../../common/properties/actions';
import PropertyEdit from './PropertyEdit';

class PropertyEditPage extends React.Component {
  componentDidMount = () => { if (this.node) { this.node.scrollIntoView(); } }

  render() {
    const {
      viewer, propertyDetails, location, updatingProperty, deletingProperty,
      deletingPropertyDone, updatingPropertyDone,
    } = this.props;

    if (deletingPropertyDone) {
      return (
        <Redirect
          to={{
            pathname: '/',
            state: { from: '/' },
          }}
        />
      );
    }

    if (updatingPropertyDone) {
      return (
        <Redirect
          to={{
            pathname: `/properties/${propertyDetails.id}`,
            state: { from: `/editProperty/${propertyDetails.id}` },
          }}
        />
      );
    }

    if (updatingProperty || deletingProperty || propertyDetails === undefined) {
      return <Loading loading loadingColor="#00E39A" backgroundColor="#ffffff" />;
    }

    if (propertyDetails === null) {
      return (
        <div>
          <div className="property-edit-page not-found">
            <Helmet title="Eign fannst ekki - Húsfinnur" />
            <Header title="Eign fannst ekki" from="/" />
            <h2>Eign fannst ekki :(</h2>
          </div>
          <Footer />
        </div>
      );
    }

    if ((!viewer || (propertyDetails && viewer.id !== propertyDetails.ownerId))) {
      return (
        <Redirect
          to={{
            pathname: '/',
            state: { from: '/' },
          }}
        />
      );
    }

    return (
      <div ref={node => (this.node = node)}>
        <Helmet title="Breyta eign - Húsfinnur" />
        <PropertyEdit propertyDetails={propertyDetails} location={location} />
      </div>
    );
  }
}

PropertyEditPage.propTypes = {
  viewer: React.PropTypes.object,
  location: React.PropTypes.any,
  params: React.PropTypes.object.isRequired,
  propertyDetails: React.PropTypes.object,
  deletingPropertyDone: React.PropTypes.bool.isRequired,
  updatingPropertyDone: React.PropTypes.bool.isRequired,
  updatingProperty: React.PropTypes.bool.isRequired,
  deletingProperty: React.PropTypes.bool.isRequired,
};

export default R.compose(
  connect(
    state => ({
      viewer: state.users.viewer,
      propertyDetails: state.properties.propertyDetails,
      deletingPropertyDone: state.properties.deletingPropertyDone,
      updatingPropertyDone: state.properties.updatingPropertyDone,
      updatingProperty: state.properties.updatingProperty,
      deletingProperty: state.properties.deletingProperty,
    }),
    { onPropertyDetailsPresence },
  ),
  firebase((database, props) => {
    const propertyDetailsPresenceRef = database.child('properties').child(props.params.propertyId);
    return [
      [propertyDetailsPresenceRef, 'on', 'value', props.onPropertyDetailsPresence],
    ];
  }),
)(PropertyEditPage);



// WEBPACK FOOTER //
// ./src/browser/propertyEdit/PropertyEditPage.js